'use strict';
var parent = require('../../stable/object/get-own-property-symbols');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/object/get-own-property-symbols.js
// module id = 547
// module chunks = 13